module.exports = __webpack_public_path__ + "static/img/banner.4f51967e.png";